import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
// Import new pages
import { AboutPage } from './pages/company/AboutPage';
import { BoardPage } from './pages/company/BoardPage';
import { TeamPage } from './pages/company/TeamPage';
import { PartnersPage } from './pages/company/PartnersPage';
import { CareersPage } from './pages/company/CareersPage';
import { ContactPage } from './pages/company/ContactPage';
import { RestaurantsPage } from './pages/concepts/RestaurantsPage';
import { PrivateDiningPage } from './pages/concepts/PrivateDiningPage';
import { GrabAndGoPage } from './pages/concepts/GrabAndGoPage';
import { CateringPage } from './pages/concepts/CateringPage';
import { ReadyToCookPage } from './pages/concepts/ReadyToCookPage';
import { AdvisoryPage } from './pages/advisory/AdvisoryPage';
import { InvestmentPage } from './pages/advisory/InvestmentPage';
import { RealEstatePage } from './pages/advisory/RealEstatePage';
import { ManagementPage } from './pages/advisory/ManagementPage';
import { MembershipsPage } from './pages/memberships/MembershipsPage';
import { PersonalPage } from './pages/memberships/PersonalPage';
import { CorporatePage } from './pages/memberships/CorporatePage';
import { PressPage } from './pages/press/PressPage';
import { NewsletterModal } from './components/NewsletterModal';
export function App() {
  const [isNewsletterOpen, setIsNewsletterOpen] = useState(false);
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-gold/30 selection:text-white flex flex-col" data-id="element-2">
        <Navbar onOpenNewsletter={() => setIsNewsletterOpen(true)} data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />

            {/* Company Routes */}
            <Route path="/company/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
            <Route path="/company/board" element={<BoardPage data-id="element-11" />} data-id="element-10" />
            <Route path="/company/team" element={<TeamPage data-id="element-13" />} data-id="element-12" />
            <Route path="/company/partners" element={<PartnersPage data-id="element-15" />} data-id="element-14" />
            <Route path="/company/careers" element={<CareersPage data-id="element-17" />} data-id="element-16" />
            <Route path="/company/contact" element={<ContactPage data-id="element-19" />} data-id="element-18" />

            {/* Concepts Routes */}
            <Route path="/concepts/restaurants" element={<RestaurantsPage data-id="element-21" />} data-id="element-20" />
            <Route path="/concepts/private-dining" element={<PrivateDiningPage data-id="element-23" />} data-id="element-22" />
            <Route path="/concepts/grab-and-go" element={<GrabAndGoPage data-id="element-25" />} data-id="element-24" />
            <Route path="/concepts/catering" element={<CateringPage data-id="element-27" />} data-id="element-26" />
            <Route path="/concepts/ready-to-cook" element={<ReadyToCookPage data-id="element-29" />} data-id="element-28" />

            {/* Advisory Routes */}
            <Route path="/advisory" element={<AdvisoryPage data-id="element-31" />} data-id="element-30" />
            <Route path="/advisory/investment" element={<InvestmentPage data-id="element-33" />} data-id="element-32" />
            <Route path="/advisory/real-estate" element={<RealEstatePage data-id="element-35" />} data-id="element-34" />
            <Route path="/advisory/management" element={<ManagementPage data-id="element-37" />} data-id="element-36" />

            {/* Memberships Routes */}
            <Route path="/memberships" element={<MembershipsPage data-id="element-39" />} data-id="element-38" />
            <Route path="/memberships/personal" element={<PersonalPage data-id="element-41" />} data-id="element-40" />
            <Route path="/memberships/corporate" element={<CorporatePage data-id="element-43" />} data-id="element-42" />

            {/* Press Route */}
            <Route path="/press" element={<PressPage data-id="element-45" />} data-id="element-44" />
          </Routes>
        </main>
        <Footer onOpenNewsletter={() => setIsNewsletterOpen(true)} data-id="element-46" />
      </div>
      <NewsletterModal isOpen={isNewsletterOpen} onClose={() => setIsNewsletterOpen(false)} data-id="element-47" />
    </BrowserRouter>;
}